import React from 'react';
import { Button } from 'antd';
// import { TimerIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { IOlympicList, useOlympicOrder } from 'modules/online-olympic';

import TimerBox from '../timer-box';

interface IProps {
  olympic?: IOlympicList;
}

const FixedSubject: React.FC<IProps> = ({ olympic }) => {
  const t = useTranslations();
  const { mutate, isLoading: isOrdering } = useOlympicOrder();

  const onOrder = () => {
    mutate({ olympicCourseId: olympic?.olympic_course_id });
  };

  return (
    <div className="h-full w-full rounded-xl bg-white p-4 sm:m-3 sm:mx-0">
      <div className="mt-2 rounded-lg bg-gray-50 p-2 font-medium">
        <div className="flex items-center justify-between">
          <p className="font-semibold">{t('fanlar')}</p>
          <p className="text-sm text-gray-700">{t('savollar_soni')}</p>
        </div>
        <hr className="!my-2 border-gray-200 bg-gray-50" />
        <div className="space-y-1 text-sm">
          {olympic?.required_subjects?.map(subject => (
            <div key={subject?.id} className="flex items-center justify-between">
              <p className="text-gray-800">{subject?.name}</p>
              <p className="text-gray-700">
                {subject?.question_count} {t('ta')}
              </p>
            </div>
          ))}
        </div>
      </div>
      {olympic?.already_participated ? (
        <p className="text-sm text-gray-600">
          {t(
            'siz_allaqachon_ushbu_olimpiadada_qatnashgansiz_iltimos_natijalarni_korish_uchun_olimpiada_tugashini_kuting'
          )}
        </p>
      ) : null}
      <div className="mt-4">
        <TimerBox status={olympic?.status} time={olympic?.end_time} />
      </div>
      {!olympic?.already_participated ? (
        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center gap-1 font-semibold">
            {/* <div className="text-indigo-600">
              <TimerIcon />
            </div>
            180 {t('daqiqa')} */}
          </div>
          <Button
            loading={isOrdering}
            onClick={onOrder}
            className="!rounded-lg !border-transparent !bg-green-600 !px-7 !py-5 !font-medium !text-white disabled:!bg-gray-100 disabled:!text-gray-400"
          >
            {t('boshlash')}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default FixedSubject;
